// src/i18n.js
// todo: dynamic way - somehow not working
// import { register, init, getLocaleFromNavigator } from 'svelte-i18n';

// register('en', () => import('./locales/en.json'));
// register('cs', () => import('./locales/cs.json'));

// init({
//   fallbackLocale: 'en',
//   initialLocale: getLocaleFromNavigator()
// });

// semi-static way
import { init, addMessages, getLocaleFromNavigator } from 'svelte-i18n';
let currentLocale = getLocaleFromNavigator();

import en from './locales/en.json';
import cs from './locales/cs.json';

addMessages('en', en);
addMessages('cs', cs);

// set locale semi-dynamically
init({
  fallbackLocale: 'en',
  initialLocale: currentLocale
});

// set html lang attribute dynamically
document.documentElement.setAttribute('lang', currentLocale);